import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import UsuarioCard from '../../components/UsuarioCard';
import styles from './styles.module.scss';
import { getListaAdmin, getListaAdminPesquisar, getAdminPendente } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';
import { useDispatch } from "react-redux"
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../store/actions/snackbarActions.js';


const Administradores = props => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const history = useHistory();
    const [usuarios, setUsuarios] = useState([])
    const [buscar, setBuscar] = useState('')
    const [ativarBuscar, setAtivarBuscar] = useState(false)
    const [pagina, setPagina] = useState(1)
    const [maxPage, setMaxPage] = useState(1)
    const [modalLoading, setModalLoading] = useState(false);

    const verMais = (maxPage > pagina);
    const listaPendente = new URLSearchParams(props.location.search).get("listaPendente")
    const getUsuarios = async(novaPagina = 1) => {
        setModalLoading(true)
        try{
            const data = listaPendente ? await getListaAdminPesquisar(1, "Aguardando") : await getListaAdmin(novaPagina)
            setPagina(novaPagina)
            setUsuarios(data.data.data)
            setMaxPage(data.data.maxPage)
        } catch(e){
            showMsgE("Ocorreu um erro e não foi possível carregar dados")
        } finally{
            setModalLoading(false)
        }
    } 
    const addPage = async () => {
        setModalLoading(true)
        try{
            const data = (!ativarBuscar) ? await getListaAdmin(pagina + 1) : await getListaAdminPesquisar(pagina + 1, buscar)
            setPagina(pagina + 1)
            setUsuarios([...usuarios, ...data.data.data])
        } catch(e){
            showMsgE("Ocorreu um erro e não foi possível carregar dados")
        } finally{
            setModalLoading(false)
        }
    }

    const findUsuarios = async () => {
        if(buscar !== ''){
            setModalLoading(true)
            try{
                const info = await getListaAdminPesquisar(1, buscar)
                setPagina(1)
                setUsuarios(info.data.data)
                setMaxPage(info.data.maxPage)
                setAtivarBuscar(true)
            }catch(e){
                showMsgE("Ocorreu um erro e não foi possível carregar dados")
            }finally{
                setModalLoading(false)
            }
        } else{
            setAtivarBuscar(false)
            getUsuarios();
        }
    }


    useEffect(() => {
        getUsuarios()
    },[])

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Administradores
            </div>
            <div className={styles.buttonWrapper}>
                <button className={`btnInvert ${styles.btAdd}`} onClick={() => {history.push('/administradores/detalhes')}}>
                    Adicionar Administrador
                </button>
            </div>
            <div className={styles.subTitle}>
                Usuários cadastrados
            </div>
            <div className={styles.buscar}>
                <FormControl>
                    <TextField  type="text"  size="small"
                        onChange={(e) => {setBuscar(e.target.value)}}
                        label="Faça sua busca"
                        value={buscar}
                        variant="filled"
                        multiline
                        className="customFilledInput"
                        onKeyDown= {
                            (e) => {
                                if (e.key === 'Enter') {
                                    findUsuarios();
                                    e.preventDefault();
                                }
                            }
                        }
                        InputProps={{endAdornment: (
                            <button onClick={findUsuarios} className={styles.searcButton}>
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        )}}
                    />
                </FormControl>
            </div>
            <div className={`${styles.acoesWrapper} ${styles.white}`}>
                {
                    Boolean(usuarios.length) ?
                        usuarios.map(
                            (usuario) => {return (
                                    <UsuarioCard usuario={usuario} key={usuario.userId}/>
                            )}
                        )
                    :
                    (
                        !modalLoading &&
                        (
                            <div>
                                Nenhum registro encontrado
                            </div>
                        )
                    )
                }
            </div>
            { verMais && (
                <div className={`${styles.verMaisWrapper} ${styles.white}`}>
                    <button className={`customButton ${styles.verMaisButton}`} onClick={addPage} >
                        Ver mais
                    </button>
                </div>
            )}
            <ModalLoading
                open={modalLoading} 
                size="lg"
            />
        </div>
    );
  
}

export default Administradores;